"use client";
import { AuthenticationOptions } from "components/AuthenticationOptions";
import ScoringLoadingModal from "components/ResumeScore/loading/ScoringLoadingModal";
import { Footer } from "home/Footer";
import { Navbar } from "home/Navbar";
import {
  useAppDispatch,
  useAppSelector,
  useSaveStateToLocalStorageOnChange,
  useSetInitialStore,
} from "lib/redux/hooks";
import {
  selectIsAuthenticationOpen,
  selectIsScoringModalOpen,
  setIsScoringModalOpen,
} from "lib/redux/uiSlice";
import { usePathname, useSearchParams } from "next/navigation";
import React, { useEffect } from "react";

const noHeaderRoutes = [
  "/resume-writing/thank-you",
  "/resume-writing/resume-status",
];
const noFooterRoutes = [
  "/resume-writing/thank-you",
  "/resume-writing/resume-status",
  "/resume-score",
];

const Layout = ({ children }: { children: React.ReactNode }) => {
  useSetInitialStore();
  useSaveStateToLocalStorageOnChange();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const dispatch = useAppDispatch();
  const isAuthenticationOpen = useAppSelector(selectIsAuthenticationOpen);
  const isScoringLoadingModalOpen = useAppSelector(selectIsScoringModalOpen);
  const hideHeader = noHeaderRoutes.includes(pathname);
  const hideFooter = noFooterRoutes.includes(pathname);

  // Initially on Page load, set the state of the modal based on the query params
  useEffect(() => {
    if (!searchParams.get("analyse")) return;
    if (searchParams.get("analyse")) {
      dispatch(setIsScoringModalOpen(false));
    }
  }, [searchParams]);

  return (
    <main className="overflow-hidden bg-[#F9F9F9]">
      {!hideHeader && <Navbar />}
      {children}
      {!hideFooter && <Footer />}
      {isAuthenticationOpen && <AuthenticationOptions />}
      {isScoringLoadingModalOpen && <ScoringLoadingModal isLoadingComplete={true}/>}
    </main>
  );
};

export default Layout;
